import { createFileRoute, redirect } from "@tanstack/react-router";

// Defensive index: a bare `.../start/les-flow` (no step segment) should never render blank.
// Portal has no such index route — it relies on step loaders — so this is an added safety net
// that forwards to step 1 while preserving the wizard's search params.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/start/les-flow/",
)({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/start/les-flow/1",
      params,
      // `true` preserves the current search params unchanged (same effect as `(prev) => prev`)
      // without forcing a structural comparison between this route's from-less (whole-app-union)
      // search type and the step-1 route's own — that comparison is unsound whenever two
      // unrelated routes reuse a key name with differently-nullable types (e.g. `klasId`).
      search: true,
    });
  },
});
